module.exports = __webpack_public_path__ + "static/media/mail-login.66a66d5a.svg";